import React from "react";
import PropTypes from "prop-types";

const Chevron = ({ isOpen, className }) => {
  const imgSrc = isOpen ? "/images/chevron-up.svg" : "/images/chevron-down.svg";

  return <img src={imgSrc} className={className} style={{ height: "12px" }} />;
};
Chevron.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  className: PropTypes.string,
};

export default Chevron;
